<template>
  <div
    id="users"
    class="row"
  >
  <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              enctype="multipart/form-data"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-file-input
                    v-model="file"
                    accept="image/*"
                    label="Seleccione para agregar una imagen "
                    type="file"
                    ref="file"
                    id="file"
                  />
                </v-col>

            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from 'vform';
import FormToolbar from '~/components/Form/Toolbar';

export default {
  middleware: 'auth',
  components: {
    FormToolbar,
  },
  props: {
    enterpriseId: { default: '' },
    action: { default: '' },
    message: { default: '' },
  },
  data: () => ({
      form: new Form({
        busy: false,
      }),
      title: '',
      file: '',
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      apiURL: '/api/enterprises',
      apiURLogo: 'logo/store',
      method: 'POST',
  }),
  computed: {
    ref() { return this.form.id; },
  },
  mounted() {
    // window.axios.get(`${this.apiURL}/${this.enterpriseId}`)
    // .then((result) => {
    //   this.name = `${result.data.name} - ${result.data.ruc}`;
    //   this.title = `Logo de ${this.name}`;
    // });
  },
  methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        const formData = new FormData();

        formData.append('file', this.file);

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        const URL = `${this.apiURL}/${this.enterpriseId}/${this.apiURLogo}`;
        window.axios.post(URL, formData, config)
        .then(() => {
          this.form.busy = false;
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      openModalDelete() {
       this.dialog = true;
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
    },
};
</script>
